import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function ProtectedRoute({ children, staffOnly = false }) {
  const { user, isStaff } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-dir-bg">
        <Loader2 className="h-8 w-8 animate-spin text-dir-gold" />
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (staffOnly && !isStaff) return <Navigate to="/dashboard" replace />;
  return children;
}
